import { Routes } from '@angular/router';
import { StatisticsComponent } from './statistics/statistics.component';
import { NavbarComponent } from './navbar/navbar.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SignatureFormComponent } from './signature-form/signature-form.component';
import { PreviewComponent } from './preview/preview.component';
import { authGuard } from './guards/auth.guard';
import { LogoutComponent } from './logout/logout.component';
import { GenemailComponent } from './genemail/genemail.component';

export const routes: Routes = [
    {
        path: 'welcome',
        component: WelcomeComponent,
        // canActivate: [authGuard]
    },
    {
        path: 'statistics',
        component: StatisticsComponent,
        canActivate: [authGuard]

    },
    {
        path: 'amrize',
        component: SignatureFormComponent,
        canActivate: [authGuard]
    },
    {
        path: 'preview',
        component: PreviewComponent,
        canActivate: [authGuard]
    },
    {
        path: 'genemail',
        component: GenemailComponent,
        canActivate: [authGuard]
    },
    {
        path: 'logout', component: LogoutComponent
    },
];
